import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import BlogList from '../../components/BlogList';


const BlogPage = (props) => {

    return (
        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className="main">
                <BlogList/>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogPage;
